import { IAttributes, IDirective, IScope, ITimeoutService } from 'angular';

interface IEventOnloadAttrs extends IAttributes {
  eventOnloadSuccess: string;
  eventOnloadError: string;
}

export function eventOnloadDirective( $timeout: ITimeoutService ): IDirective {
  return {
    restrict: 'A',
    link: ( scope: IScope, element, attrs: IEventOnloadAttrs ) => {
      element.on('load', ( event ) => {
        const { eventOnloadSuccess } = attrs;
        if ( eventOnloadSuccess ) {
          $timeout(() => {
            scope.$eval(eventOnloadSuccess, { $event: event });
          });
        }
      });

      element.on('error', ( event ) => {
        if ( attrs.eventOnloadError ) {
          $timeout(() => {
            scope.$eval(attrs.eventOnloadError, { $event: event });
          });
        }
      });
    }
  };
}

eventOnloadDirective.$inject = [
  '$timeout'
];



// WEBPACK FOOTER //
// ./app/shared/directives/event-onload/event-onload.directive.ts